import { Stack } from '@mui/material';
import React from 'react';
import * as Redux from 'react-redux';
import * as IMG from '../../../helpers/ImagesUtils';
import { getFilesArchivos } from '../../archivos/HelpersArchivos';
import {
  FIRMA_STYLES_CONST,
  LOGO_LEFT_BACK_STYLES_CONST,
  LOGO_RIGHT_BACK_STYLES_CONST,
  QRCODE_STYLES_CONST,
  SUBTITLE_BACK_STYLES_CONST,
  TITLE_BACK_STYLES_CONST,
  TITLE_FIRMA_STYLES_CONST,
} from '../ConstCarnet';
import CodeqrCarnetComponent from './components_carnet/CodeqrCarnet';
import ImageCarnetComponent from './components_carnet/ImageCarnet';
import TextCarnetComponent from './components_carnet/TextCarnet';

const ReverseCarnet = ({ valueCodeqr, data, notEdit = false, qrRef }) => {
  const carnetStore = Redux.useSelector((state) => state.carnet);

  return (
    <Stack
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      <TextCarnetComponent
        name={TITLE_BACK_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={
          data?.titleBackText ??
          'El portador(a) de este credencial es bandista regular de la Institucion Adscrita a la entidad'
        }
      />
      <TextCarnetComponent
        name={SUBTITLE_BACK_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={
          data?.subtitleBackText ??
          'En caso de pérdida favor llamar al teléfono: +584241598593'
        }
      />

      <TextCarnetComponent
        name={TITLE_FIRMA_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={data?.titleFirmaText ?? 'FIRMA DEL DIRECTOR(A)'}
      />

      <CodeqrCarnetComponent
        name={QRCODE_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={valueCodeqr}
        qrRef={qrRef}
      />

      <ImageCarnetComponent
        name={LOGO_LEFT_BACK_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={
          carnetStore.activo.logoLeftBack
            ? getFilesArchivos(carnetStore.activo?.logoLeftBack)
            : IMG.logoColor
        }
        // updatePosition={updatePosition}
      />
      <ImageCarnetComponent
        name={LOGO_RIGHT_BACK_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={
          carnetStore.activo.logoRightBack
            ? getFilesArchivos(carnetStore.activo?.logoRightBack)
            : IMG.logoColor
        }
        // updatePosition={updatePosition}
      />
      <ImageCarnetComponent
        name={FIRMA_STYLES_CONST}
        notEdit={notEdit}
        carnetStore={carnetStore}
        value={
          carnetStore.activo.firma
            ? getFilesArchivos(carnetStore.activo?.firma)
            : IMG.logoColor
        }
        // updatePosition={updatePosition}
      />
    </Stack>
  );
};

export default ReverseCarnet;
